import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

/* Services */
import { Api } from "./API.service";
import { getAuthToken } from "./Auth.service";
import { ApiRoute } from "./../config/Base.config";

/* Interfaces */

/* configs */
import { apiAuthURL, apiAdminURL, apiShipmentURL } from "../config/App.config";

export class AuthApi extends Api {
  public constructor() {
    super();

    // // this middleware is been called right before the http request is made.
    this.instance.interceptors.request.use((param: AxiosRequestConfig) => ({
      ...param,
    }));

    // // this middleware is been called right before the response is get it by the method that triggers the request
    this.instance.interceptors.response.use((param: AxiosResponse) => ({
      ...param,
    }));
    this.setToken(getAuthToken());
    this.logout = this.logout.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  public async logout(): Promise<any> {
    try {
      return await this.delete<any, AxiosResponse<any>>(`${apiAuthURL}${ApiRoute.logout}`)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getProfile(): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getProfile}`;
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getCustomerPortalPermission(token: string): Promise<any> {
    let url = `${apiShipmentURL}${ApiRoute.getCustomerPortalPermission}`;
    try {
      return await this.get<any, AxiosResponse<any>>(url, { headers: { authorization: token } })
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getUserDetail(id: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getUserDetail}`.replace(`{user.id}`, id);
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async updateUserDetail(formData: any): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.updateUserDetail}`;
    return await this.put<string, any, AxiosResponse<any>>(url, formData).then(this.success);
  }

  public async getTimezones(): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getTimezones}`;
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getCurrencies(): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getCurrencies}`;
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async changeUserPreferences(data?: any): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.changeUserPreferences}`;
    try {
      return await this.post<any, AxiosResponse<any>>(url, data)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getEmailOtp(email: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getEmailOtp}`.replace("{email}", encodeURIComponent(email));
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getPhoneNumberOtp(phoneCodeId: string, mobileNo: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getPhoneNumberOtp}`
      .replace("{phoneCodeId}", phoneCodeId)
      .replace("{mobileNo}", mobileNo);
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async verifyEmailOtp(otp: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.verifyEmailOtp}`.replace("{otp}", otp);
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async verifyPhoneNumberOtp(otp: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.verifyPhoneNumberOtp}`.replace("{otp}", otp);
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getAllLanguages(): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.get_all_languages}`;
    try {
      return await this.get<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getLogoNonLogin(organisation: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getLogoNonLogin}`.replace("{organisation}", organisation);
    try {
      return await this.getWithNonToken<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async getRegisteredOrganisations(param: string): Promise<any> {
    let url = `${apiAdminURL}${ApiRoute.getRegisteredOrganisations}${param}`;
    try {
        return await this.getWithNonToken<any, AxiosResponse<any>>(url)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public async login(data: any): Promise<any> {
    let url = `${apiAuthURL}${ApiRoute.login}`;
    try {
      return await this.post<any, AxiosResponse<any>>(url, data)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }

  public loginV2(data: any): Promise<any> {
    let url = `${apiAuthURL}${ApiRoute.loginV2}`;
    return this.post<any, AxiosResponse<any>>(url, data).then(this.success);
  }

  public async loginV3(data: any): Promise<any> {
    let url = `${apiAuthURL}${ApiRoute.loginV3}`;
    return this.post<any, any, AxiosResponse<any>>(url, data).then(this.success);
  }

  public async refreshToken(data: any): Promise<any> {
    let url = `${apiAuthURL}${ApiRoute.refreshToken}`;
    return this.post<any, any, AxiosResponse<any>>(url, data).then(this.success);
  }

  public async changePassword(data: any): Promise<any> {
    let url = `${apiAuthURL}${ApiRoute.updatePassword}`;
    try {
      return await this.post<any, AxiosResponse<any>>(url,data)
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  }
}
